/**
 *   Generated file. Do not edit
 */

import { ScramLoginParams } from './models';
import { ScramLoginResponseBody } from './models';
import { EncryptedIVRequest } from './models';
import { EncryptedIVResponse } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

declare module '@iotize/tap/client/impl/lib/frame/tap-stream-core' {
  export interface TapStreamReader {
    readScramLoginParams(): ScramLoginParams;

    readScramLoginResponseBody(): ScramLoginResponseBody;

    readEncryptedIVRequest(): EncryptedIVRequest;

    readEncryptedIVResponse(): EncryptedIVResponse;
  }
  export interface TapStreamWriter {
    writeScramLoginParams(model: ScramLoginParams): TapStreamWriter;

    writeScramLoginResponseBody(model: ScramLoginResponseBody): TapStreamWriter;

    writeEncryptedIVRequest(model: EncryptedIVRequest): TapStreamWriter;

    writeEncryptedIVResponse(model: EncryptedIVResponse): TapStreamWriter;
  }
}

TapStreamReader.prototype.readScramLoginParams = function (): ScramLoginParams {
  const model: Partial<ScramLoginParams> = {};

  model.username = this.readString(16);

  model.clientNonce = this.readUnsigned(4);

  return model as ScramLoginParams;
};

TapStreamReader.prototype.readScramLoginResponseBody =
  function (): ScramLoginResponseBody {
    const model: Partial<ScramLoginResponseBody> = {};

    model.serverNonce = this.readUnsigned(4);

    model.salt = this.readBytes(4);

    model.iterationNumber = this.readUnsigned(4);

    return model as ScramLoginResponseBody;
  };

TapStreamReader.prototype.readEncryptedIVRequest =
  function (): EncryptedIVRequest {
    const model: Partial<EncryptedIVRequest> = {};

    model.iv = this.readBytes(16);

    model.request = this.readBytes();

    return model as EncryptedIVRequest;
  };

TapStreamReader.prototype.readEncryptedIVResponse =
  function (): EncryptedIVResponse {
    const model: Partial<EncryptedIVResponse> = {};

    model.iv = this.readBytes(16);

    model.response = this.readBytes();

    return model as EncryptedIVResponse;
  };

// TapStreamWriter.prototype.write(model: ScramLoginParams) : TapStreamWriter{
//     return this.writeScramLoginParams(model)
// }

TapStreamWriter.prototype.writeScramLoginParams = function (
  model: ScramLoginParams,
): TapStreamWriter {
  this.writeString(model.username, 16);

  this.writeUnsigned(model.clientNonce, 4);

  return this;
};

// TapStreamWriter.prototype.write(model: ScramLoginResponseBody) : TapStreamWriter{
//     return this.writeScramLoginResponseBody(model)
// }

TapStreamWriter.prototype.writeScramLoginResponseBody = function (
  model: ScramLoginResponseBody,
): TapStreamWriter {
  this.writeUnsigned(model.serverNonce, 4);

  this.writeBytes(model.salt, 4);

  this.writeUnsigned(model.iterationNumber, 4);

  return this;
};

// TapStreamWriter.prototype.write(model: EncryptedIVRequest) : TapStreamWriter{
//     return this.writeEncryptedIVRequest(model)
// }

TapStreamWriter.prototype.writeEncryptedIVRequest = function (
  model: EncryptedIVRequest,
): TapStreamWriter {
  this.writeBytes(model.iv, 16);

  this.writeBytes(model.request);

  return this;
};

// TapStreamWriter.prototype.write(model: EncryptedIVResponse) : TapStreamWriter{
//     return this.writeEncryptedIVResponse(model)
// }

TapStreamWriter.prototype.writeEncryptedIVResponse = function (
  model: EncryptedIVResponse,
): TapStreamWriter {
  this.writeBytes(model.iv, 16);

  this.writeBytes(model.response);

  return this;
};
